import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20organic%20shapes%20in%20coral%20orange%20and%20gold%20tones%2C%20minimalist%20modern%20design%2C%20smooth%20textures%2C%20elegant%20atmosphere&width=1920&height=600&seq=cta-bg-home&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-600/90 to-primary-700/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">{t('ctaTitle')}</h2>
          <p className="text-sm md:text-base text-white/80 mb-8">{t('ctaSubtitle')}</p>
          <Link
            to="/about#contact"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white text-primary-600 rounded-full text-sm font-semibold hover:bg-white/95 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('ctaButton')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}